import MaxDiffChart from './MaxDiffChart';
import { useMaxDiff } from '../../hooks/useAnalytics';

function MaxDiffChartSlot({ databaseId, chart, companyId }) {
  const { data: response, isLoading, error } = useMaxDiff(databaseId, chart.key, companyId);
  const rows = Array.isArray(response?.data) ? response.data : [];
  return (
    <MaxDiffChart
      data={rows}
      title={chart.label}
      color={chart.color}
      loading={isLoading}
      error={error ? 'Failed to load MaxDiff data' : null}
    />
  );
}

export default function MaxDiffChartsSection({ databaseId, charts, companyId }) {
  if (!charts || charts.length === 0) return null;
  return (
    <div className="space-y-4 mb-6">
      {charts.map((chart) => (
        <MaxDiffChartSlot
          key={chart.key}
          databaseId={databaseId}
          chart={chart}
          companyId={companyId}
        />
      ))}
    </div>
  );
}
